import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import { LanguageProvider } from "./i18n/LanguageContext";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { Toaster } from "sonner";
import Home from "./pages/Home";
import Bowling from "./pages/Bowling";
import Arrangementen from "./pages/Arrangementen";
import Kinderfeestjes from "./pages/Kinderfeestjes";
import Restaurant from "./pages/Restaurant";
import Jenever from "./pages/Jenever";
import Faq from "./pages/Faq";
import Contact from "./pages/Contact";
import Reserveer from "./pages/Reserveer";
import Admin from "./pages/Admin";
import { SparkleFX } from "./components/SparkleFX";
import { ChristmasFX } from "./components/ChristmasFX";

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <SparkleFX />
          <ChristmasFX />
          <ScrollManager />
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/bowling" element={<Bowling />} />
            <Route path="/arrangementen" element={<Arrangementen />} />
            <Route path="/kinderfeestjes" element={<Kinderfeestjes />} />
            <Route path="/restaurant" element={<Restaurant />} />
            <Route path="/jenever-discobowling" element={<Jenever />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/reserveer" element={<Reserveer />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
          <Footer />
        </BrowserRouter>
        <Toaster theme="dark" position="bottom-right" />
      </LanguageProvider>
    </div>
  );
}

export default App;
